import * as React from 'react'
import {BlockSpacer} from '../../../../../styledComponents/ResponsiveConvenience'
import NatResidentApplicationDetailConfirmItem from '../../common/resident/NatResidentApplicationDetailConfirmItem'
import {RESIDENCE_STYLE} from '../../../../../CodeMaster'

interface Props {
    condominiumName: string
    selectedRidgeName: string
    showRidgeItem: boolean
    roomNumber: string
    familyName: string
    firstName: string
    familyNameKana: string
    firstNameKana: string
    residenceStyle: string
    mailAddress: string
}

const NatResidentUserRegistrationConfirm: React.FC<Props> = props => {
    const {
        condominiumName,
        selectedRidgeName,
        showRidgeItem,
        roomNumber,
        familyName,
        firstName,
        familyNameKana,
        firstNameKana,
        residenceStyle,
        mailAddress,
    } = props

    const codeMasterResidenceStyle =
        residenceStyle ? RESIDENCE_STYLE.codeToEnumConstants(residenceStyle) : undefined;
    const residenceStyleLabel =
        codeMasterResidenceStyle ? (
        codeMasterResidenceStyle !== RESIDENCE_STYLE.APPROPRIATOR_AND_TENANT ?
            codeMasterResidenceStyle.label : '占有者（賃貸でお住まい）') : '';

    const items = []
    items.push(`マンション名：${condominiumName}`)
    if (showRidgeItem) {
        items.push(`棟名：${selectedRidgeName}`)
    }
    items.push(`部屋番号：${roomNumber}`)
    items.push(`氏名：${familyName} ${firstName}（${familyNameKana} ${firstNameKana}）`)
    items.push(`居住形態：${residenceStyleLabel}`)
    items.push(`メールアドレス：${mailAddress}`)
    items.push('口座番号（下4桁）：****')
    return (
        <>
            <NatResidentApplicationDetailConfirmItem
                title={'申請者情報'}
                items={items}
            />
            <BlockSpacer height={'5px'}/>
        </>
    )
}

NatResidentUserRegistrationConfirm.displayName = 'NatResidentUserRegistrationConfirm'
export default NatResidentUserRegistrationConfirm
